import { Link } from 'react-router-dom';

const DivisionsPreview = () => {
  const divisions = [
    {
      icon: 'ri-plant-line',
      title: 'Palm Oil',
      company: 'Drixem Mega Sdn Bhd',
      description:
        'Malaysia\'s leading palm oil specialist offering mill & refinery setup, premium CP6, CP8, CP10 exporting, and OEM contract manufacturing with government certifications.',
      features: ['Mill & Refinery Setup', 'CP6, CP8, CP10 Export', 'OEM Manufacturing'],
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Manufacturing',
      company: 'Drixem Nexus Manufacturing Sdn Bhd',
      description:
        'Palm cooking oil packaging plant with AP Export permit, handling end-to-end production from refining to bottling, labelling, and international distribution.',
      features: ['Packaging Plant', 'AP Export Permit', 'OEM Branding'],
    },
    {
      icon: 'ri-building-line',
      title: 'Property Development',
      company: 'Heuliez (M) Sdn Bhd',
      description:
        'Established since 1996, specializing in strategic land-bank acquisition and property development projects across Malaysia.',
      features: ['Est. Since 1996', 'Land Acquisition', 'Property Development'],
    },
    {
      icon: 'ri-ship-line',
      title: 'B2B Export Trade',
      company: 'Aravion Zeus Sdn Bhd',
      description:
        'Global B2B export trade hub connecting Malaysian products to international markets across five continents.',
      features: ['Global Trade Network', 'Multi-Currency', '5 Continents'],
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Advertising & Marketing',
      company: 'Drixem Sdn Bhd',
      description:
        'MSC Status company specializing in advertising, marketing strategy, branding, and creative campaign management.',
      features: ['MSC Status 2006', 'Brand Strategy', 'Creative Campaigns'],
    },
    {
      icon: 'ri-robot-line',
      title: 'AI IT Tech',
      company: 'Nexa Prime Sdn Bhd',
      description:
        'Pioneering Physical AI — integrating artificial intelligence with hardware, logistics, and industrial infrastructure to transform real-world business operations at scale.',
      features: ['Physical AI', 'AI Solutions', 'Custom Software'],
    },
  ];

  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary-50 rounded-full mb-6">
            <i className="ri-robot-line text-primary-600"></i>
            <span className="text-sm text-primary-700 font-medium">Physical AI-Powered Closed-Loop Ecosystem</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold text-gray-900 mb-4 sm:mb-6">
            Six Profit Engines, One Powerhouse
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Each division is a <strong>standalone revenue generator</strong> — together, they form an unstoppable conglomerate delivering diversified, resilient returns
          </p>
          <div className="mt-4 inline-flex items-center space-x-2 px-3 sm:px-5 py-2 bg-accent-50 border border-accent-200 rounded-full">
            <i className="ri-information-line text-accent-600"></i>
            <span className="text-xs sm:text-sm text-accent-700 font-medium">New investors &amp; partners are limited to involvement in one division/subsidiary only</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {divisions.map((division, index) => (
            <div
              key={index}
              className="group bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-xl mb-6 group-hover:scale-110 transition-transform">
                <i className={`${division.icon} text-3xl text-primary-600`}></i>
              </div>

              <h3 className="text-xl font-bold text-gray-900 mb-1">
                {division.title}
              </h3>
              <p className="text-sm text-primary-600 font-semibold mb-4">
                {division.company}
              </p>

              <p className="text-gray-600 mb-6 leading-relaxed text-sm">
                {division.description}
              </p>

              <ul className="space-y-3 mb-6">
                {division.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center space-x-3">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-check-line text-primary-600"></i>
                    </div>
                    <span className="text-sm text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <Link
                to="/divisions"
                className="inline-flex items-center space-x-2 text-primary-600 hover:text-primary-700 font-semibold transition-colors cursor-pointer text-sm"
              >
                <span>Learn More</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DivisionsPreview;
